import { useState } from "react";
import { Input } from "@/components/ui/input";

const formatter = new Intl.NumberFormat("vi-VN", {
  maximumFractionDigits: 6,
});

function parsePrice(text: string): number | null {
  const compact = text.trim().replace(/\s/g, "");
  if (compact === "") return 0;

  let normalized: string;
  if (compact.includes(",")) {
    // Vietnamese format: dots group thousands, comma separates decimals.
    if (!/^(?:\d+|\d{1,3}(?:\.\d{3})+),\d*$/.test(compact)) return null;
    normalized = compact.replace(/\./g, "").replace(",", ".");
  } else if (/^\d{1,3}(?:\.\d{3})+$/.test(compact)) {
    normalized = compact.replace(/\./g, "");
  } else {
    // Also accept ungrouped decimal-dot input, e.g. 18000.99.
    if (!/^\d+(?:\.\d*)?$/.test(compact)) return null;
    normalized = compact;
  }

  const value = Number(normalized);
  return Number.isFinite(value) ? value : null;
}

export function UnitPriceInput({
  value,
  onChange,
  label,
}: {
  value: number;
  onChange: (value: number) => void;
  label: string;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");

  return (
    <Input
      type="text"
      inputMode="decimal"
      aria-label={label}
      value={editing ? draft : formatter.format(value)}
      onFocus={(event) => {
        event.target.setCustomValidity("");
        setDraft(value === 0 ? "" : formatter.format(value));
        setEditing(true);
        event.target.select();
      }}
      onChange={(event) => {
        const text = event.target.value;
        const parsed = parsePrice(text);
        setDraft(text);
        event.target.setCustomValidity(
          parsed === null ? "Enter a valid unit price, e.g. 18.000,99." : "",
        );
        if (parsed !== null) onChange(parsed);
      }}
      onBlur={(event) => {
        if (parsePrice(event.target.value) !== null) {
          event.target.setCustomValidity("");
          setEditing(false);
        }
      }}
      className="h-8 text-sm w-full min-w-[100px]"
    />
  );
}
